import ReactTooltip from 'react-tooltip';
import { formatMhrSyncTime } from '../utils';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { useLocation } from 'react-router-dom';
import { ArrowRepeat, InfoCircleFill } from 'react-bootstrap-icons';
import { usePatientProfile } from '../hooks';

const MHRSync = () => {
  const location = useLocation();
  const { patientProfile } = useSelector(
    (state: RootState) => state.patientProfile,
  );
  const searchParams = new URLSearchParams(location.search);

  const accessToken = searchParams.get('access_token');
  const { handleSyncClick, isSynced } = usePatientProfile();
  return (
    <div className="d-flex flex-column gap-1">
      <button
        type="button"
        disabled={isSynced}
        className="d-flex flex-row align-items-center gap-2 ms-auto"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSyncClick(accessToken!);
        }}
      >
        <span className="dark-grey txtBody">Sync MHR</span>
        <ArrowRepeat color="#6a7277" size={14} />
      </button>
      {!isSynced && (
        <span className="text-end font-11 font-weight-400 mid-grey roboto">
          {formatMhrSyncTime(patientProfile.lastSync)}
        </span>
      )}
      {isSynced && (
        <div className="d-flex flex-row align-items-center justify-content-end text-end gap-2">
          <span className="font-12 font-weight-400 mid-grey roboto">
            MHR sync in progress
          </span>
          <span data-tip data-for="syncHeaderTip" className="centered-text">
            <InfoCircleFill color="#6a7277" size={14} />
          </span>
          <ReactTooltip id="syncHeaderTip">
            <div className="my-2">
              Refresh the page
              <br />
              to check the progress
            </div>
          </ReactTooltip>
        </div>
      )}
    </div>
  );
};

export default MHRSync;
